export enum DispensingAvgTime {
    min = 14,
    max = 35,
    minGood = 21,
    maxGood =  28,
}

export enum PressureAvg {
    min = 6,
    max = 12,
    minGood = 8,
    maxGood =  10,
}

export enum BoilerServicesPressureAvg {
    min = 0.7,
    max = 1.6,
    minGood = 1,
    maxGood =  1.3,
}

export enum BoilerTemperatureAvg {
    min = 84,
    max = 102,
    minGood = 90,
    maxGood =  96,
}

export enum GroupTemperatureAvg {
    min = 84,
    max = 102,
    minGood = 90,
    maxGood =  96,
}

export enum FluxAvg {
    min = 0.2,
    max = 1.8,
    minGood = 0.8,
    maxGood =  1.2,
}
